import { z } from 'zod';

export const createBlogCategorySchema = z.object({
  name: z.string().min(1, 'Name is required'),
  slug: z.string().optional(),
  description: z.string().optional(),
  active: z.boolean().default(true),
});
export type CreateBlogCategoryRequest = z.infer<typeof createBlogCategorySchema>;

export const updateBlogCategorySchema = createBlogCategorySchema.partial();
export type UpdateBlogCategoryRequest = z.infer<typeof updateBlogCategorySchema>;

export const createBlogPostSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  slug: z.string().optional(),
  excerpt: z.string().optional(),
  content: z.string().min(1, 'Content is required'),
  bannerImage: z.string().optional(),
  categoryId: z.string().min(1, 'Category is required'),
  published: z.boolean().default(false),
});
export type CreateBlogPostRequest = z.infer<typeof createBlogPostSchema>;

export const updateBlogPostSchema = createBlogPostSchema.partial();
export type UpdateBlogPostRequest = z.infer<typeof updateBlogPostSchema>;
